import Auth0 from "react-native-auth0"

import Firebase from "../firebase"
import Sentry from "../sentry"

var jwtDecode = require("jwt-decode")

function getClient() {
  const domain = Firebase.getConfigValue("auth0_domain")
  const clientId = Firebase.getConfigValue("auth0_clientid")
  return new Auth0({ domain, clientId })
}

async function refreshToken(creds) {
  if (!creds.refreshToken) {
    console.log("CREDS REFRESH TOKEN NULL:", creds)
    return null
  }
  console.log(
    "REFRESHING CREDENTIALS: ",
    Date.now() / 1000 - creds.dateIssued,
    creds.expiresIn,
  )
  return getClient()
    .auth.refreshToken({ refreshToken: creds.refreshToken })
    .then(c => {
      let userId = jwtDecode(creds.idToken)
      const newCreds = {
        ...c,
        userId,
        dateIssued: Math.floor(Date.now() / 1000),
      }
      return newCreds
    })
    .catch(error => {
      console.log("REFRESH ERROR: ", error)
      Sentry.logError(error)
      return null
    })
}

async function login(username, password) {
  let scope = Firebase.getConfigValue("auth0_scope")
  let audience = Firebase.getConfigValue("auth0_audience")
  let realm = Firebase.getConfigValue("auth0_connection")

  console.log("realm", realm)
  return getClient()
    .auth.passwordRealm({ scope, audience, username, password, realm })
    .then(credentials => {
      console.log(
        "TOKEN: ",
        credentials.accessToken,
        `\nREFRESH TOKEN: `,
        credentials.refreshToken,
        `\nEXPIRES IN: `,
        credentials.expiresIn,
      )
      if (credentials.idToken) {
        let userId = jwtDecode(credentials.idToken)
        return {
          success: true,
          creds: {
            ...credentials,
            dateIssued: Math.floor(Date.now() / 1000),
            userId,
          },
        }
      }
    })
    .catch(error => {
      Sentry.logError(error)
      console.log(error)
      return { success: false, error }
    })
}

function logout() {}

export default {
  login,
  logout,
  refreshToken,
}
